export default __webpack_public_path__ + "static/media/franchise-template-1-fr.b9ec220d.svg";